import PropTypes from 'prop-types';

import './DropdownBackground.scss';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

function DropdownBackground({ children }) {
  return <div className="DropdownBackground">{children}</div>;
}

DropdownBackground.propTypes = propTypes;
DropdownBackground.defaultProps = defaultProps;

export default DropdownBackground;
